import React, { ReactElement } from 'react';

import { Container, Text } from '@constellation/core';
import NeedHelpWrapper from 'components/needHelpWrapper/NeedHelpWrapper';
import { Accordion, Link } from 'components/tagging';
import getLabel from '../../utils/getLabel';

function SmsNeedHelp(): ReactElement {
  return (
    <Container padding="none">
      <NeedHelpWrapper>
        <Accordion
          label={getLabel('needHelp.smsMobileNoIncorrect.title')}
          variation="standalone"
          className="accordian_label"
          marginBottom="02"
        >
          <Text>
            {getLabel('needHelp.smsMobileNoIncorrect.content_1')}{' '}
            <Link href={getLabel('needHelp.smsMobileNoIncorrect.supportLink')} external>
              {getLabel('needHelp.smsMobileNoIncorrect.content_2')}
            </Link>
            .
          </Text>
        </Accordion>
      </NeedHelpWrapper>
    </Container>
  );
}

export default SmsNeedHelp;
